import * as Yup from "yup";

export const validationSchema = [
  {
    name: "name",
    placeholder: "Tên App",
    validate: Yup.string()
      .required("Vui lòng nhập tên App")
  },
  {
    name: "packageName",
    placeholder: "Package name",
    validate: Yup.string()
      .required("Vui lòng nhập package name")
  },
  {
    name: "version",
    placeholder: "Ex: 0.0.0",
    validate: Yup.string()
      .required("Vui lòng nhập Version")
  },
  {
    name: "installFileUrl",
    placeholder: "Chọn file",
    validate: Yup.string()
      .required("Vui lòng chọn file")
  },
  {
    name: "installFileSize",
    placeholder: "Nhập kích thước",
    validate: Yup.string()
      .required("Vui lòng nhập kích thước")
  },
  {
    name: "imageUrl",
    placeholder: "Chọn ảnh đại diện",
    validate: Yup.string()
      .required("Vui lòng chọn ảnh đại diện")
  },
  {
    name: "isActive",
    placeholder: "Chọn tình trạng",
    validate: Yup.string().required("Vui lòng chọn trạng thái"),
    defaultValue: true,
  },
];
